export default {
  "status": {
    "runtime": {
      "completed": true
    },
    "errors": {
      "data": {
        "code": "",
        "description": ""
      }
    }
  },
  "response": {
    "data": [
      {
        "tag": "altro-online",
        "description": "Altro"
      },
      {
        "tag": "altuoservizio.conad.it",
        "description": "Altuoservizio.conad.it"
      },
      {
        "tag": "basko.it",
        "description": "basko.it"
      },
      {
        "tag": "bennetdrive.it",
        "description": "bennetdrive.it"
      },
      {
        "tag": "carrefour.it",
        "description": "Carrefour.it"
      },
      {
        "tag": "cicalia.com",
        "description": "Cicalia.com"
      },
      {
        "tag": "cliccaevai.esselunga.it",
        "description": "Cliccaevai.esselunga.it"
      },
      {
        "tag": "cosicomodo.it",
        "description": "Cosicomodo.it"
      },
      {
        "tag": "craispesaonline.it",
        "description": "Craispesaonline.it"
      },
      {
        "tag": "dambros.it",
        "description": "Dambros.it"
      },
      {
        "tag": "easycoop.com",
        "description": "easycoop.com"
      },
      {
        "tag": "esselungaacasa.it",
        "description": "Esselungaacasa.it"
      },
      {
        "tag": "iperalspesaonline.it",
        "description": "iperalspesaonline.it"
      },
      {
        "tag": "mymercato.it",
        "description": "mymercato.it"
      },
      {
        "tag": "pamacasa.pampanorama.it",
        "description": "pamacasa.pampanorama.it"
      },
      {
        "tag": "spesasicura.com",
        "description": "Spesasicura.com"
      },
      {
        "tag": "supermercatideco.it",
        "description": "supermercatideco.it"
      },
      {
        "tag": "supermercatidok.it",
        "description": "supermercatidok.it"
      },
      {
        "tag": "supermercato24.it",
        "description": "Supermercato24.it"
      },
      {
        "tag": "tigros.it",
        "description": "tigros.it"
      },
      {
        "tag": "unes.it",
        "description": "unes.it"
      }
    ]
  }
}